import {CognitoUserPool} from 'amazon-cognito-identity-js'

export default new CognitoUserPool({
    UserPoolId: 'us-east-1_ZOK6QwwmZ',
    ClientId: 'e73g2rs92hbqp747qmb82rn93'
})